export const TELEPHONE_CODE = '+1';
